import Box from '@mui/material/Box'
import styled from '@mui/system/styled'
import { isOnELearning } from 'src/modules/ETesting/events'

export const StyledContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: isOnELearning() ? 'calc(100vh - 186px)' : 'calc(100vh - 200px)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(5),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  gap: theme.spacing(5),
}))

export const StyledContent = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 20,
}))
